(function () {

    SUGApp.config(['$routeProvider', '$compileProvider', function ($routeProvider, $compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(http|https|mailto|data):/);
        $routeProvider
            .when('/', {
                templateUrl: '/view/tools/portals/dspPortalPublic.html',
                controller: 'portalPublicController',
                controllerAs: 'portal',
                resolve:  {
                    /* get the urlkey from the path, since it is before the angular route, we need to parse window.location.pathname to get it
                     * url is expected to be in the form: [protocol]://[hostname]/org/urlkey
                     */
                    urlkey: function () {
                       return window.location.pathname.split('/').pop();
                    }
                }
            })
            .otherwise({
                redirectTo: '/'
            });
    }]);

}());

(function () {
    /* Controller */
    SUGApp.controller('portalPublicController', portalPublicController);
    portalPublicController.$inject = ['$scope','$q','$sce','$window', 'sugCacheFactory', 'SUGUtilities','errorService', 'portalService', 'urlkey'];
    function portalPublicController(  $scope, $q, $sce , $window, sugCacheFactory, SUGUtilities, errorService, portalService, urlkey ) {

        var portal = this;

        /**
         * For any data the directives might need set it here.
         * Use directiveData for common/generic values like member id
         * You can add a Section specific object  for data that only pertains to one Directive type: ex. contactDirectiveData
         * ~~DO NOT~~ change the var names as they are shared here and in the internal portalEditController.js
         */
        portal.directiveData = {};

        portal.portalinfo = {};
        /* These will be set by view controllers */
        portal.strings = {
            alert: {
                  title:      ''
                , message:    ''
                , type:       ''
            }
            , errorsTitle:              'Uh oh!'
            , errorsPleaseCorrect:      'Please correct the errors below:'
            , helpBody:                 ''
            , helpTitle:                ''
            , noFilteredData:           'No data matched your filter criteria. Please try again.'
            , pageDescr:                ''
            , pageTitle:                ''
            , settingsCategoryName:     'PortalPages'
            , ttipHelp:                 'Help'
        };

        //Note: Text is updated below in loadData() to add a Contact Page Link
        $scope.emptypagewarning = {
            type:         'warning'
          , title:        ''
          , text:         'This portal page is currently empty. Please _contactlink_ for more information and assistance.'
          , dismissable:  false
          , show:         true
          , noshadow:     true
      };

        //init error service
        portal.es = errorService;

        // Handler for Processing Status
        $scope.$on('isProcessing', function (event, isProcessing) {
            portal.processing = isProcessing;
            if (portal.processing) {
                SUGUtilities.showLoading('processing');
            }
        });


        // this runs first
        var init = function() {
            SUGUtilities.broadCast('isProcessing', true);
            portal.urlkey = urlkey ? urlkey : '';

            loadData();
        };

        /**
         * Load data from the backend
         */
        var loadData = function(){
            getPortalData( portal.urlkey )
            .then(function (portalData) {
                // remove any subscribe sections that have no groups assigned so they won't display
                portalData.portalsections.forEach(function ( objsection, index ) {
                    if( objsection.sectionkey === 'subscribe' ){
                        var content = JSON.parse(objsection.sectioncontent);
                        if( typeof content.groups === 'undefined' || content.groups.length === 0 || (content.groups.length === 1 && content.groups[0] === 0) ){
                            portalData.portalsections.splice(index,1);
                        }
                    }
                });

                portal.portalinfo = portalData;
                portal.strings.pageTitle = portalData.portal.title;
                portal.schemeStyles = getSchemeStyles(portalData.colorscheme.schemedata);

                portal.directiveData.portalInfo = (typeof portalData != 'undefined') ? portalData : {};
                //set the parentId and MemberId for use
                portal.parentId = portalData.portal.memberid;
                portal.directiveData.parentId = portalData.portal.memberid;
                portal.directiveData.memberId = portalData.portal.memberid;
                portal.directiveData.fullsecureurl = ( typeof window.globalcfg.secureURL != 'undefined' ) ? window.globalcfg.secureURL : 'https://www.signupgenius.com';
                sugCacheFactory.set('parentId', portalData.portal.memberid );

                //determine if we have any visible sections
                portal.directiveData.emptyPage = isPublicPageEmpty();

                //determine the last publically visible section
                if( !portal.directiveData.emptyPage ){
                   portal.directiveData.portalInfo.portal.lastvisiblesectionid = lastVisibleSectionId();
                } else {
                    //if not visible then parse together the contact page link and update the warning message
                    var contactlink = '?go=c.help&mid=' + portalData.portal.memberid + '&pid=' + portalData.portal.id + '&sid=0&uky=' + encodeURI( portalData.portal.urlkey ) + '&portal=1';
                    $scope.emptypagewarning.text = $scope.emptypagewarning.text.replace(/_contactlink_/g, '<a href="' + contactlink + '">contact the portal owner</a>');

                    //

                }

                //set tab/window title to the portal title value
                document.title = portalData.portal.title;

                SUGUtilities.broadCast('isProcessing', false);
            });
        };

        /**
         * Gets the dynamic CSS using the color scheme values.
         * @param {Object} schemecolors - object containing colors for different parts of a portal page
         */
        var getSchemeStyles = function(schemecolors){
            schemecolors = SUGUtilities.isDefinedNotNullNotEmpty(schemecolors) ? JSON.parse(schemecolors) : {};
            var schemeStyles = portalService.generateSchemeStyles(schemecolors,'#portalContentContainer, .sub-footer.nobrand, .spacer-lg','#portalContentContainer');
            // Broadcast an event with the updated info so the schemeStyles directive (portalColorScheme.js) can update.
            SUGUtilities.broadCast('portal_schemestyles', {'css':schemeStyles });
            return schemeStyles;
        };

        /**
         * Get all the data for the portal with the specified urlkey.
         *
         * @param {String} urlkey - urlkey for the portal
         * @param {Boolean} blnForceRefresh - force refresh of the cache
         */
        var getPortalData = function ( urlkey, blnForceRefresh) {
            var deferred = $q.defer();
            var portalData = sugCacheFactory.get('PortalData',{});

            if (SUGUtilities.isUndefinedOrEmptyObject(portalData) || blnForceRefresh) {
                // if nothing is cached, look up live data
                portalService.getPortalByUrl_Public( { urlKey: urlkey } )
                    .then(function (response) {
                        var r = SUGUtilities.lowerCaseKeys(response.data);
                        if (SUGUtilities.ajaxResultInvalid(response.data)) {
                            // if the portal was not found, redirect the user to the not found page
                            if( Array.isArray(r.message) && r.message[0] === 'Portal not found.'){
                                $window.location.href = '/index.cfm?go=c.resourceNotFound&resource=portal';
                            }else{
                                // invalid response, show error
                                portal.es.setError('portal-top-level', SUGUtilities.getAjaxResponseMessage(response) );
                            }
                        } else {
                            // successfully retrieved data, update portal
                            portalData = r.data;
                            // add public flag
                            portalData.portal['mode'] = 'public';
                            sugCacheFactory.set('PortalData',portalData);
                        }
                        deferred.resolve(portalData);
                    });
            } else {
                deferred.resolve(portalData);
            }

            return deferred.promise;
        };

        /* Returns Member Id */
        var getParentId = function (blnForceRefresh) {
            var deferred = $q.defer();
                // Call common function in the Service
                portalService.getParentId(blnForceRefresh)
                .then(function (response) {
                    deferred.resolve(response);
                },
                function( errormessage ){
                    // invalid response, show error
                    portal.es.setError('portalpages', errormessage );
                });

            return deferred.promise;
        };

        /**
         * Internal utility function to determine if the last section is visible on the public portal page
         * This is used to determine if the last section on the page shows a divider line or not
         */
        var lastVisibleSectionId = function(){
            var returnSectionId = 0;
            //loop through the sections array in reverse (last to first) until we hit last visisble section
            for (var idx = portal.portalinfo.portalsections.length-1; idx >= 0; idx--) {

                //If the section is visble then return its ID and stop/break
                var lastSection = portal.portalinfo.portalsections[ idx ];
                if( Object.keys( lastSection ).length ){
                    var parsedContent = JSON.parse( lastSection.sectioncontent );
                    switch (lastSection.sectionkey) {
                        case 'files':
                            if( parsedContent.files.length > 0 ){ returnSectionId = lastSection.id; }
                            break;
                        case 'subscribe':
                            if( parsedContent.groups[0] > 0 ){ returnSectionId = lastSection.id; }
                            break;
                        default:
                            //all the other sections are always visible so you can just return the ID
                            returnSectionId = lastSection.id;
                            break;
                    }
                    //As soon as we have a visble last section then break out of the loop
                    if( returnSectionId ){ break; }
                }
            }
            return returnSectionId;
        };

        /**
         * Method returns a boolean to determine if the public page has any content
         * To do this we verify that at least one of the sections included has content
         */
        var isPublicPageEmpty = function(){
            //if we have portal sections, check them
            if( portal.portalinfo.portalsections.length ){

                //loop through the sections array in reverse (last to first) until we hit last visisble section
                for (var idx = 0; idx <= portal.portalinfo.portalsections.length-1; idx++) {

                    //If the section is visble then return its ID and stop/break
                    var portalSection = portal.portalinfo.portalsections[ idx ];
                    if( Object.keys( portalSection ).length ){
                        switch (portalSection.sectionkey) {
                            case 'files':
                                if( JSON.parse( portalSection.sectioncontent ).files.length == 0 ){ return 1; }
                                break;
                            case 'subscribe':
                                if( JSON.parse( portalSection.sectioncontent ).groups[0] == 0 ){ return 1; }
                                break;
                            default:
                                //all the other sections are always visible so if we have one return
                                return 0;
                                break;
                        }
                    }
                }
            } else {
                //if no sections then nothing is visible, so page is empty (true)
                return 1;
            }
        };

        init();
    }
}());